import {NgModule, ModuleWithProviders} from '@angular/core';
import {HttpModule} from '@angular/http';

import {RxHttp} from './';


@NgModule({
    imports: [HttpModule],
    providers: [{ provide: RxHttp, useClass: RxHttp } ],
})
export class RxHttpModule {

}


// WEBPACK FOOTER //
// ./node_modules/@rx/http/http.module.ts